var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentType,_vm._b({tag:"component",staticClass:"btn-dropdown-list-item",class:{
    'btn-dropdown-list-item--danger': _vm.danger,
    'no-underline': _vm.isLink,
    'btn--disabled': _vm.disabled,
  },on:{"click":_vm.onClick}},'component',_vm.buttonAttrs,false),[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }